// Reality Check Demo — independent pre-auth demo-route gate (house pattern).
//
// Gates the #reality-check-demo route: a no-auth, no-DB, no-production-data investor/customer
// walkthrough that runs the REAL engine chain + the REAL RealityCheckReportSection on bundled
// candles. Deliberately SEPARATE from realityCheckReportFlag so the demo can be shown without
// touching the in-builder feature (and vice-versa). Default OFF. Precedence:
//   1. local kill  (localStorage 'reality_check_demo_kill'=1)   → off
//   2. env override (VITE_REALITY_CHECK_DEMO = on|off)
//   3. local opt-in (localStorage 'reality_check_demo_optin'=1)  → on
//   4. default                                                   → OFF

import { publicEnv } from './clientEnv';

export type RealityCheckDemoGate = { enabled: boolean; reason: string };

export const REALITY_CHECK_DEMO_OPTIN_KEY = 'reality_check_demo_optin';
export const REALITY_CHECK_DEMO_KILL_KEY = 'reality_check_demo_kill';

function ls(key: string): string | null {
  try { return typeof localStorage !== 'undefined' ? localStorage.getItem(key) : null; } catch { return null; }
}

export function realityCheckDemoGate(): RealityCheckDemoGate {
  const on = (reason: string): RealityCheckDemoGate => ({ enabled: true, reason });
  const off = (reason: string): RealityCheckDemoGate => ({ enabled: false, reason });

  if (ls(REALITY_CHECK_DEMO_KILL_KEY) === '1') return off('local_kill');
  const e = (publicEnv('VITE_REALITY_CHECK_DEMO') ?? '').toLowerCase();
  if (e === 'on') return on('env_on');
  if (e === 'off') return off('disabled_globally');
  if (ls(REALITY_CHECK_DEMO_OPTIN_KEY) === '1') return on('local_optin');
  return off('default_off');
}

export function engageRealityCheckDemo(on: boolean): void {
  try {
    if (on) localStorage.setItem(REALITY_CHECK_DEMO_OPTIN_KEY, '1');
    else localStorage.removeItem(REALITY_CHECK_DEMO_OPTIN_KEY);
  } catch { /* ignore */ }
}
